import { easeCurves } from "../eases/eases";
import { css } from 'styled-components';
import { theme } from "../../theme";
/**
 * all the props accepted by the drag transition.
 */

var EXPANDED_PADDING = 4;
var BACKGROUND_DEFAULT = theme.colors.palette.brandPrimary;
var BACKGROUND_ACTIVE = '#48A2FF';
var DURATION_DEFAULT = 150;
var DURATION_ACTIVE = 200;
/**
 * A simple Highlight transition can toggle if "active" or not as well as selecting a background color.
 * Available css variables for consumption by children:
 * ```
 * --vapor-highlight-transition-ease
 * --vapor-highlight-transition-duration
 *```
 *
 * Optional configurations:
 * @param {number} [props.expandedPadding=4]
 * @param {number} [props.durationActive=200]
 * @param {number} [props.durationDefault=150
 * @param {string} [props.backgroundActive='#48A2FF']
 * @param {string} [props.backgroundDefault=theme.colors.palette.brandPrimary]
 *
 * @example
 * const HighlightComponent = styled.div`
 *  ${transitionHighlight({
      backgroundActive: `#2c2c3b`,
      backgroundDefault: `#21212D`,
    })}
 * `;
 *
 *
 * @param {boolean} isActive toggles transition between the two states.
 *
 * @example
 * ```jsx
 *  <HighlightComponent isActive={isFocused}>
 *    {...children}
 *  </HighlightComponent>
 * ```
 */

export var transitionHighlight = function transitionHighlight() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$expandedPaddin = props.expandedPadding,
      expandedPadding = _props$expandedPaddin === void 0 ? EXPANDED_PADDING : _props$expandedPaddin,
      _props$durationActive = props.durationActive,
      durationActive = _props$durationActive === void 0 ? DURATION_ACTIVE : _props$durationActive,
      _props$durationDefaul = props.durationDefault,
      durationDefault = _props$durationDefaul === void 0 ? DURATION_DEFAULT : _props$durationDefaul,
      _props$backgroundActi = props.backgroundActive,
      backgroundActive = _props$backgroundActi === void 0 ? BACKGROUND_ACTIVE : _props$backgroundActi,
      _props$backgroundDefa = props.backgroundDefault,
      backgroundDefault = _props$backgroundDefa === void 0 ? BACKGROUND_DEFAULT : _props$backgroundDefa;
  return css(["--vapor-highlight-transition-ease:", ";--vapor-highlight-transition-duration:", ";&:before{content:'';position:absolute;z-index:0;top:0px;left:0px;width:", ";height:", ";background-color:", ";transition-property:transform,width,height,background-color;transition-timing-function:var(--vapor-highlight-transition-ease);transition-duration:var(--vapor-highlight-transition-duration);display:block;transform:", ";}> *{position:relative;transition:transform var(--vapor-highlight-transition-ease) var(--vapor-highlight-transition-duration);transform:", ";}"], function (p) {
    return p.isActive ? easeCurves.easeOutQuint : easeCurves.decelerate;
  }, function (p) {
    return p.isActive ? "".concat(durationActive, "ms") : "".concat(durationDefault, "ms");
  }, function (p) {
    return p.isActive ? "calc(100% + ".concat(expandedPadding * 2, "px)") : "100%";
  }, function (p) {
    return p.isActive ? "calc(100% + ".concat(expandedPadding * 2, "px)") : "100%";
  }, function (p) {
    return p.isActive ? backgroundActive : backgroundDefault;
  }, function (p) {
    return p.isActive ? "translate3d(-".concat(expandedPadding, "px, -").concat(expandedPadding, "px, 0px)") : "translate3d(0px, 0px, 0px)";
  }, function (p) {
    return p.isActive ? "translate3d(0px, -".concat(expandedPadding, "px, 0px)") : "translate3d(0px, 0px, 0px)";
  });
};